export default __webpack_public_path__ + "static/share-logo-800f2232043179f6149b6a9f51895ee8.jpg";